import { __generator } from "tslib";
import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import i18next from 'i18next';
import { Url } from '@wix/da-url';
import { reduxModuleLoaded, subscribeToTier, unsubRequest, unsubRequestByUsername, changeTier, pushChangeTierModal, } from './actions';
import { request } from '../../../xhr';
import { isApiError } from '../../../xhr/request';
import { pushModal, replaceModal, popModal, } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
import { getCurrentUser } from '../../../publicSession/selectors';
export function fakeUnsubscribeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        return { success: true };
    }
}
export function fakeCheckUpgradeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        return {};
    }
}
function handleSubscribeToTier(_a) {
    var currentUser, response;
    var _b, _c, _d, _e;
    var tier = _a.payload.tier;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, select(getCurrentUser)];
            case 1:
                currentUser = _f.sent();
                if (!(currentUser.username === ((_b = tier.author) === null || _b === void 0 ? void 0 : _b.username))) return [3 /*break*/, 3];
                return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.changePopup.selfSubFailure.title'),
                            text: i18next.t('deviation.tier.changePopup.selfSubFailure.text'),
                            confirmBtnLabel: i18next.t('deviation.tier.changePopup.selfSubFailure.accept'),
                        }
                    }))];
            case 2:
                _f.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: '/tier/check_upgrade',
                    params: {
                        tierid: (_c = tier.tier) === null || _c === void 0 ? void 0 : _c.tierId,
                    },
                }, fakeCheckUpgradeResponse)];
            case 4:
                response = _f.sent();
                if (!isApiError(response)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.changePopup.failure.title'),
                            text: i18next.t('deviation.tier.changePopup.failure.body'),
                            confirmBtnLabel: i18next.t('deviation.tier.changePopup.failure.accept'),
                        },
                    }))];
            case 5:
                _f.sent();
                return [2 /*return*/];
            case 6:
                if (!(response === null || response === void 0 ? void 0 : response.currentTier)) return [3 /*break*/, 8];
                return [4 /*yield*/, put(pushChangeTierModal(response === null || response === void 0 ? void 0 : response.currentTier, tier, response === null || response === void 0 ? void 0 : response.isDowngrade))];
            case 7:
                _f.sent();
                return [3 /*break*/, 9];
            case 8:
                if ((_d = tier.tier) === null || _d === void 0 ? void 0 : _d.subproductId) {
                    window.location.href = Url.checkoutLink((_e = tier.tier) === null || _e === void 0 ? void 0 : _e.subproductId);
                }
                _f.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
function handleUnsubRequest(_a) {
    var response, reloadPage;
    var _b;
    var tier = _a.payload.tier;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/tier/unsubscribe',
                    data: {
                        tierid: (_b = tier.tier) === null || _b === void 0 ? void 0 : _b.tierId,
                    },
                }, fakeUnsubscribeResponse)];
            case 1:
                response = _c.sent();
                return [4 /*yield*/, put(popModal())];
            case 2:
                _c.sent();
                if (!isApiError(response)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.unsubPopup.failure.title'),
                            text: i18next.t('deviation.tier.unsubPopup.failure.body'),
                            confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.failure.accept'),
                        },
                    }))];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4:
                reloadPage = function () {
                    window.location.reload();
                };
                return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.unsubPopup.success.title'),
                            text: i18next.t('deviation.tier.unsubPopup.success.body', {
                                tierName: tier.title,
                            }),
                            confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.success.accept'),
                            // Refresh any stale state
                            onConfirm: reloadPage,
                            onCancel: reloadPage,
                        },
                    }))];
            case 5:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleUnsubRequestByUsername(_a) {
    var response, redirectToSubscriptions;
    var username = _a.payload.username;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/tier/user/unsubscribe',
                    data: {
                        subscribed_to_username: username,
                    },
                }, fakeUnsubscribeResponse)];
            case 1:
                response = _b.sent();
                if (!isApiError(response)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(replaceModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.unsubPopup.failure.title'),
                            text: i18next.t('deviation.tier.unsubPopup.failure.body'),
                            confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.failure.accept'),
                        },
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                redirectToSubscriptions = function () {
                    window.location.href = Url.userSubscriptionsPath({
                        username: username,
                    });
                };
                // We have to use replaceModal to keep the <TierConsumerReduxModule />
                // loaded and keep this saga active until the final confirmation modal is shown
                return [4 /*yield*/, put(replaceModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.unsubPopup.success.title'),
                            text: i18next.t('deviation.tier.unsubPopup.success.body.generic'),
                            confirmBtnLabel: i18next.t('deviation.tier.unsubPopup.success.accept'),
                            // Refresh any stale state
                            onConfirm: redirectToSubscriptions,
                            onCancel: redirectToSubscriptions,
                        },
                    }))];
            case 4:
                // We have to use replaceModal to keep the <TierConsumerReduxModule />
                // loaded and keep this saga active until the final confirmation modal is shown
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleChangeTier(_a) {
    var response;
    var _b, _c, _d;
    var _e = _a.payload, currentTier = _e.currentTier, newTier = _e.newTier;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/tier/unsubscribe',
                    data: {
                        tierid: (_b = currentTier.tier) === null || _b === void 0 ? void 0 : _b.tierId,
                    },
                }, fakeUnsubscribeResponse)];
            case 1:
                response = _f.sent();
                if (!isApiError(response)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(pushModal(ModalType.CONFIRMATION, {
                        params: {
                            withCancelButton: false,
                            title: i18next.t('deviation.tier.changePopup.failure.title'),
                            text: i18next.t('deviation.tier.changePopup.failure.body'),
                            confirmBtnLabel: i18next.t('deviation.tier.changePopup.failure.accept'),
                        },
                    }))];
            case 2:
                _f.sent();
                return [2 /*return*/];
            case 3:
                if ((_c = newTier.tier) === null || _c === void 0 ? void 0 : _c.subproductId) {
                    window.location.href = Url.checkoutLink((_d = newTier.tier) === null || _d === void 0 ? void 0 : _d.subproductId);
                }
                return [2 /*return*/];
        }
    });
}
export default function subscribeSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([
                        takeEvery(subscribeToTier, handleSubscribeToTier),
                        takeEvery(unsubRequest, handleUnsubRequest),
                        takeEvery(unsubRequestByUsername, handleUnsubRequestByUsername),
                        takeEvery(changeTier, handleChangeTier),
                    ])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=subscribeSaga.js.map